{
    "overlay.type.OpenSnowMap": "Pistes ski",
    "overlay.type.IGN Pentes": "Cartes des Pentes",
    "overlay.type.sommet": "Sommets",
    "overlay.type.obstacle": "Obstacles",
    "overlay.type.IGN Traces hivernales": "Traces hivernale",
    "overlay.type.refuge": "Refuges",
    "overlay.type.zsm": "Zones sensibilité majeure",
    "overlay.type.dz": "Drop Zone",
    "overlay.type.information": "Information",
    "overlay.type.zone_environnement": "Zone règlementée",
    "overlay.type.accueil_pn_gn": "Accueil PN/GN",
    "overlay.type.orange": "Orange",
    "overlay.type.sfr": "SFR",
    "overlay.type.free": "Free",
    "overlay.type.bouygues": "Bouygues",
    "overlay.type.ponctuel": "Ponctuel",
    "overlay.type.zone_orsec": "Zone ORSEC",
    "overlay.type.drone": "Drone",
    "overlay.type.air_obstacle": "Autres obstacles aériens",
    "overlay.type.highline": "Highline",
    "overlay.type.cable": "Cable",
    "overlay.type.catex": "Catex",
    "overlay.type.enedis": "Lignes HT",
    "overlay.type.acces_vsav": "Accès VSAV",
    "overlay.type.acces_vltt": "Accès VLTT",
    "overlay.type.balise_vtt": "Balise VTT",
    "overlay.type.piste_vtt": "Pistes VTT",
    "overlay.type.structure_ffvl": "Structure FFVL",
    "overlay.type.atterrissage_ffvl": "Atterrissage",
    "overlay.type.decollage_ffvl": "Décollage",
    "overlay.type.balise_ffvl": "Balises",
    "overlay.type.parking": "Parking",
    "overlay.type.site_escalade": "Sites escalade",
    "overlay.type.radio": "Relais radio",
    "overlay.type.structure_medicale": "Structure médicale",
    "overlay.type.webcam": "webcams",
    "overlay.type.zone_air": "Zone AIR",
    "overlay.type.traffic_air": "Traffic AIR",
    "overlay.type.usem": "Unités CRS/PGHM",
    "overlay.type.speleo": "Spéléo",
    "overlay.type.canyon": "Canyoning",
    "overlay.type.point_passage": "Point de passage",
    "overlay.type.itineraire": "Itinéraire",
    "overlay.type.zone_flux": "Zone de flux",
    "overlay.type.via_ferrata": "Via Ferrata",
    "overlay.type.balise_PDIPR": "Balise PDIPR",
    "overlay.type.piste_VTT": "Piste VTT",
    "overlay.type.balise_VTT": "Balise VTT",
    "event.overlay.type.dz_event": "DZ Secours",
    "event.overlay.type.event": "Événement",
    "event.overlay.type.zone": "Zone",
    "event.overlay.type.zone_recherche": "Zone de recherche",
    "event.overlay.type.zone_calcul": "Zone de calcul",
    "event.overlay.type.ligne": "Ligne divers",
    "event.overlay.type.trace": "Trace",
    "event.overlay.type.gendloc": "GendLoc",
    "event.overlay.type.geolocation": "Géolocalisation",
    "event.overlay.type.message": "Message",
    "event.overlay.type.POI": "Point d'intérêt",
    "event.overlay.type.poi_ok": "Point OK",
    "event.overlay.type.poi_interrogation": "Point à vérifier",
    "event.overlay.type.victime": "Victime",
    "event.overlay.type.temoin": "Témoin",
    "event.overlay.type.vehicule": "Véhicule",
    "event.overlay.type.status": "Statut",
    "event.overlay.type.poste_commandement": "Poste de commandement",
    "event.overlay.type.point_regroupement_moyens": "Point de regroupement moyens",
    "event.overlay.type.point_regroupement_victimes": "Point de regroupement victimes",
    "document.type.photo": "Photo",
    "document.type.Documentphoto": "Document",
    "document.type.trace": "Trace",
    "events.ofTheDay": "Événements du jour",
    "events.partnersOfTheDay": "Événements partenaires du jour",
    "events.ofTheYear": "Événements de l'année",
    "service.search.BAN": "BASE ADRESSE NATIONALE",
    "service.search.DBNYME_GPF": "TOPONYME IGN",
    "service.search.nominatim": "BASE NOMINATIM",
    "service.search.ign_commune_gpf": "COMMUNE IGN",
    "service.search.overlay": "BASE INTERNE OVERLAYS",
    "service.search.results.header.city": "Commune",
    "service.search.results.header.name": "Nom",
    "service.search.results.header.type": "Type",
    "service.search.results.header.zipCode": "CP",
    "http.404": "Service introuvable",
    "http.403": "Accès au service refusé",
    "http.503": "Service indisponible",
    "http.504": "Le service a mis trop de temps à répondre",
    "event.status.DEPART": "Départ",
    "event.status.ASL": "Arrivé sur les lieux",
    "event.status.EVAC": "Evacuation",
    "event.status.DEPOSE": "Dépose",
    "event.status.CH": "Dépose",
    "event.status.RETOUR": "Retour à la base",
    "event.status.FIN": "Fin de mission",
    "common.true": "Oui",
    "common.false": "Non",
    "common.1": "Oui",
    "common.0": "Non",
    "sms.status.SENT": "Envoyé",
    "sms.status.SENDING": "En cours d'envoi",
    "sms.status.RECEIVED": "Délivré",
    "sms.status.EXPIRED": "Expiré",
    "sms.status.ERROR": "Erreur",
    "sms.status.PERMISSION": "Permission",
    "sms.status.TIME_OUT": "Délai dépassé",
    "sms.status.OK": "Ok",
    "sms.status.UNKNOWN_STATUS": "Etat inconnu",
    "error.websocket": "Une erreur est survenue avec le flux '{{name}}'.<br/>Le rafraichissement automatique ne marchera pas.",
    "logout": "Se déconnecter",
    "documentation": "Documentation",
    "settings_overlays": "Gestion des informations carte",
    "new_event": "Créer nouvel événement",
    "toponymSearch": "Recherche toponymes et objets",
    "coordinateSearch": "Recherche par coordonnées",
    "sms_status": "SMS",
    "helico_status": "Statut hélicoptères",
    "error.invalid_credentials": "Identifiants invalides"
}